// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3bbZn","error":"Textarea_error__31kcX","readonly":"Textarea_readonly__21_sS","disabled":"Textarea_disabled__3WtRQ"};